import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Brush,
  AreaChart,
  Area,
  ResponsiveContainer,
} from "recharts";

import { Text, Box } from "@chakra-ui/react";

const PriceAndVolatility = ({ data }) => {
  return (
    <div style={{ width: "100%" }}>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          height={200}
          data={data}
          syncId="price_and_vol"
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <XAxis dataKey="ts" />
          <YAxis />
          <Tooltip />
          <Line
            dot={false}
            type="monotone"
            dataKey="price"
            stroke="#8884d8"
            fill="#8884d8"
          />
        </LineChart>
      </ResponsiveContainer>

      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          height={200}
          data={data}
          syncId="price_and_vol"
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <XAxis dataKey="ts" />
          <YAxis />
          <Tooltip />
          <Line
            dot={false}
            type="monotone"
            dataKey="volatility"
            stroke="#82ca9d"
            fill="#82ca9d"
          />
          <Brush />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PriceAndVolatility;
